// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"ada4754cfb7f90c0","6831":"cd83593d95397f89","8503":"da7f1f2285b46411","9683":"be015eec86abb25f"}[chunkId] + ".js";
};